export const SplitFeesRouting = {
  gpo: 'gpo',
  community: 'community',
  processing: 'processing'
}

export const SPLIT_FEES_OPTIONS = [
  {
    label: 'Admin, led by GPO',
    value: SplitFeesRouting.gpo
  },
  {
    label: 'Admin, led by Сommunity',
    value: SplitFeesRouting.community
  },
  {
    label: 'OM Community processing',
    value: SplitFeesRouting.processing
  }
]
